import Decimal from '@libs/shared/utils/decimal';
import { SocialCreditWorkPaymentsObject } from '../object-type/folder/social-credit-work-payments.object';
import { SocialCreditPreservedPayment, SocialCreditWorkOffer } from '../types/social-credit-work.types';

export function getPreservedCreditPayments(
    context: SocialCreditWorkPaymentsObject, offers: SocialCreditWorkOffer[],
    folderId: number | null, date: Date, groupId: number | null,
): SocialCreditPreservedPayment[] {
    if (context.folderId !== folderId) return [];
    const sameDate = new Date(context.dateFrom).getTime() === date.getTime();
    const used = new Set<number>();
    const preserved: SocialCreditPreservedPayment[] = [];
    for (const payment of context.payments) {
        if (!sameDate && (groupId === null || payment.groupId !== groupId)) continue;
        const offerIndex = offers.findIndex((offer, index) => !used.has(index) && offer.payByCredits === true
            && offer.offerId === payment.offerId && offer.applications === payment.applications);
        if (offerIndex < 0) continue;
        used.add(offerIndex);
        preserved.push({ payment, offerIndex });
    }
    return preserved;
}

export function getReleasedCreditAmount(
    context: SocialCreditWorkPaymentsObject, preserved: SocialCreditPreservedPayment[], folderId: number | null,
): number {
    if (context.folderId !== folderId) return 0;
    const preservedIds = new Set(preserved.map(item => item.payment.id));
    return Number(context.payments.filter(payment => !preservedIds.has(payment.id))
        .reduce((sum, payment) => sum.add(new Decimal(payment.releasableAmount)), new Decimal(0)).toString());
}

export function getCreditOfferAmount(applications: number, price: number | string): number {
    return Number(new Decimal(price).multiply(new Decimal(applications)).toString());
}
